import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

var animatedHeroContainer = document.getElementById('animatedHeroContainer');

//if an animated hero is detected
if (animatedHeroContainer) {
  //var for responsive animation
  var screenWidth = window.innerWidth;
  var h;
  var isDesktop = true;

  if (screenWidth < 1024 && screenWidth >= 768) {
    //tablet
    h = 715;
    isDesktop = false;
  } else if (screenWidth < 768) {
    //mobile
    h = 486;
    isDesktop = false;
  }

  let tl = gsap.timeline({
    scrollTrigger: {
      markers: false,
      trigger: '#animatedHero',
      pin: false,
      start: '15% top',
      end: 'bottom bottom',
    },
    onComplete: function () {
      animatedHeroContainer.classList.add('postAnimationHeroContainer');
    },
  });

  //if desktop
  if (isDesktop) {
    animatedHeroContainer.classList.add('postAnimationHeroContainer');
  } else {
    tl.to(
      animatedHeroContainer,
      {
        height: h,
        duration: 2,
      },
      0
    );
  }
}
